import React from "react";
import LOGO from "../images/Macys_Logo_Nextgen.svg";
import HAMBERGER_IMG from "../images/hamberger.png";
import USER from "../images/user.svg";
import DOWNARROW from "../images/down_arrow.png";
import WARNING from "../images/warning-icon.svg";
import CHECKMARK from "../images/checkmark-icon.svg";
import TOOLTIP from "../images/tooltip-icon.svg";
import AGREEMENT from "../images/agreement.png";
import INFO from "../images/info.svg";
import NOTE from "../images/note.svg";
import ACTION from "../images/action.png";
import DELETE from "../images/delete-icon.jpg";
import SEARCH from "../images/search.svg";
import WORDICON from "../images/word_icon.png";
import TEXTICON from "../images/text_icon.png";
import PDFICON from "../images/pdf_icon.png";
import EXCELICON from "../images/excel_icon.png";
import UPLOADICON from "../images/upload_icon.png";
import ADDICON from "../images/add_icon.png";
import FOLDERICON from "../images/folder_icon.svg";
import INFOICON from "../images/info_icon.png";
import DOWNLOADICON from "../images/download_icon.svg";
import DISABLEDDOWNLOADICON from "../images/disabled_download_icon.svg";
import LOCKICON from "../images/lock_icon.svg";
import MAXIMISEICON from "../images/full-screen-50.png";
import MINIMISEICON from "../images/full-screen-exit-50.png";
import UNLOCKICON from "../images/unlock-icon-18.png";
import LOADER_SPIN from "../images/loading-gif-png-5.gif";

export const MACYS_LOGO = (props) => {
  return (
    <img
      src={LOGO}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const HAMBERGER = (props) => {
  return (
    <img
      src={HAMBERGER_IMG}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const USER_ICON = (props) => {
  return (
    <img
      src={USER}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const DOWN_ARROW = (props) => {
  return (
    <img
      src={DOWNARROW}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const WarningIcon = (props) => {
  return (
    <img
      src={WARNING}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const CheckMarkIcon = (props) => {
  return (
    <img
      src={CHECKMARK}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const TooltipIcon = (props) => {
  return (
    <img
      src={TOOLTIP}
      alt={props.altText}
      id={props.id}
      className={props.style}
      title={props.title}
    ></img>
  );
};

export const AGREEMENT_ICON = (props) => {
  return (
    <img
      src={AGREEMENT}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const Info = (props) => {
  return (
    <img
      src={INFO}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const Notes = ({ altText, id, style, ...rest }) => {
  return <img src={NOTE} alt={altText} id={id} className={style} {...rest} />;
};

export const Action = (props) => {
  return (
    <img
      src={ACTION}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};
export const DELETE_ICON = (props) => {
  return (
    <img
      src={DELETE}
      alt={props.altText}
      id={props.id}
      data-testid={props.testId}
      className={props.style}
    ></img>
  );
};
export const SEARCH_ICON = (props) => {
  return (
    <img
      src={SEARCH}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const WORD_ICON = (props) => {
  return (
    <img
      src={WORDICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const TEXT_ICON = (props) => {
  return (
    <img
      src={TEXTICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const PDF_ICON = (props) => {
  return (
    <img
      src={PDFICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const EXCEL_ICON = (props) => {
  return (
    <img
      src={EXCELICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const UPLOAD_ICON = (props) => {
  return (
    <img
      src={UPLOADICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const ADD_ICON = (props) => {
  return (
    <img
      src={ADDICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};
export const FOLDER_ICON = (props) => {
  return (
    <img
      src={FOLDERICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const INFO_ICON = (props) => {
  return (
    <img
      src={INFOICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const DOWNLOAD_ICON = (props) => {
  return (
    <img
      src={DOWNLOADICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const DISABLED_DOWNLOAD_ICON = (props) => {
  return (
    <img
      src={DISABLEDDOWNLOADICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const LOCK_ICON = (props) => {
  return (
    <img
      src={LOCKICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const MAXIMISE_ICON = (props) => {
  return (
    <img
      src={MAXIMISEICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};
export const MINIMISE_ICON = (props) => {
  return (
    <img
      src={MINIMISEICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const UNLOCK_ICON = (props) => {
  return (
    <img
      src={UNLOCKICON}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};

export const SPIN_LOADER = (props) => {
  return (
    <img
      src={LOADER_SPIN}
      alt={props.altText}
      id={props.id}
      className={props.style}
    ></img>
  );
};